import type { AuthService } from "@domain/port/AuthService";
import type { LoginRequest, TokenBundle } from "../model/Auth";
import type { SessionStore } from "../port/SessionStore";

export interface Login {
  execute(req: LoginRequest): Promise<void>;
}

export class LoginImpl implements Login {
  constructor(
    private readonly service: AuthService,
    private readonly sessionStore: SessionStore,
  ) {}

  async execute(req: LoginRequest): Promise<void> {
    const res: TokenBundle = await this.service.login(req);
    this.sessionStore.set(res);
  }
}
